module.exports = __webpack_public_path__ + "static/media/elearnmarkets.268f5fe5.png";